<div class="page-container">
	<app-parent-profile [id]="user.id" *ngIf="user" (completed)="onCompleted()"></app-parent-profile>	
</div>
